var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#D7DFE5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "#EFF2F5",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_16168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9208 41.9936C49.9208 43.0192 49.7499 44.0067 49.4371 44.9268L47.9569 43.4466C48.054 42.9684 48.1027 42.4816 48.1023 41.9936V40.1751C48.1023 39.9339 48.1981 39.7027 48.3686 39.5322C48.5392 39.3616 48.7704 39.2658 49.0116 39.2658C49.2527 39.2658 49.484 39.3616 49.6545 39.5322C49.825 39.7027 49.9208 39.9339 49.9208 40.1751V41.9936ZM40.8283 49.2676C42.3159 49.2676 43.6979 48.8221 44.8509 48.0547L46.1565 49.3622C44.8573 50.3014 43.3328 50.8805 41.7376 51.0406V54.7231H47.1931C47.4342 54.7231 47.6655 54.8189 47.836 54.9894C48.0065 55.1599 48.1023 55.3912 48.1023 55.6323C48.1023 55.8735 48.0065 56.1048 47.836 56.2753C47.6655 56.4458 47.4342 56.5416 47.1931 56.5416H34.4636C34.2224 56.5416 33.9912 56.4458 33.8207 56.2753C33.6501 56.1048 33.5543 55.8735 33.5543 55.6323C33.5543 55.3912 33.6501 55.1599 33.8207 54.9894C33.9912 54.8189 34.2224 54.7231 34.4636 54.7231H39.9191V51.0406C37.6763 50.8152 35.5972 49.7648 34.0851 48.0931C32.573 46.4214 31.7358 44.2477 31.7358 41.9936V40.1751C31.7358 39.9339 31.8316 39.7027 32.0022 39.5322C32.1727 39.3616 32.4039 39.2658 32.6451 39.2658C32.8862 39.2658 33.1175 39.3616 33.288 39.5322C33.4585 39.7027 33.5543 39.9339 33.5543 40.1751V41.9936C33.5543 43.9228 34.3207 45.7729 35.6848 47.1371C37.049 48.5012 38.8992 49.2676 40.8283 49.2676ZM46.2838 32.9011V41.7736L35.6602 31.1499C36.0765 29.9265 36.9135 28.8905 38.0221 28.2264C39.1307 27.5623 40.439 27.3132 41.7141 27.5234C42.9892 27.7336 44.1484 28.3894 44.9852 29.3742C45.822 30.359 46.2822 31.6088 46.2838 32.9011Z",
    fill: "#365D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.53 46.7347L35.3722 38.5751V41.9939C35.3719 42.9491 35.6225 43.8878 36.0988 44.7158C36.5752 45.5439 37.2606 46.2323 38.0865 46.7123C38.9125 47.1923 39.85 47.447 40.8053 47.4509C41.7606 47.4549 42.7001 47.2079 43.53 46.7347ZM29.2729 29.9081L51.0949 51.7301L52.3824 50.4426L30.5604 28.6206L29.2729 29.9081Z",
    fill: "#365D7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_16168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.0909,
    height: 29.0909,
    fill: "white",
    transform: "translate(27.4546 27.4546)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicRound);
export default __webpack_public_path__ + "static/media/mic-round.b6212e7183e8b16c3a5bc76bf2c780f6.svg";
export { ForwardRef as ReactComponent };